export default __webpack_public_path__ + "static/media/Fullscreen.27fbcf5b.svg";